import React from "react";
import { Button } from "components/bootstrap";
import { IfPermitted } from "components/common";
import { createGRN } from "logic/permissions/GRN";
import useCollectionEntityMutation from "collections/hooks/useCollectionEntityMutation";
import { useTranslation } from "react-i18next";
const EntityActions = ({ id, type, collectionId }) => {
  const { t } = useTranslation("enterprise_collections");
  const { addEntities } = useCollectionEntityMutation(collectionId);
  const onAdd = () => {
    addEntities({ addedEntities: [createGRN(type, id)] });
  };
  return /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `collection_entities:edit:${collectionId}` }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", bsStyle: "primary", onClick: onAdd }, t("shared.add")));
};
export default EntityActions;
